import React, { useState, useEffect } from "react";
import { Form, Button, Table } from "react-bootstrap";
import HRPagination from "components/HRPagination";
import { formatDate } from "utils/date";

const HolidayViewManagement = React.memo(
  ({
    isAllowedToUpdate = false,
    isAllowedToDelete = false,
    handleCheckboxChange = () => {},
    handleEdit = () => {},
    deleteHolidayManage = () => {},
    selectedRow = null,
  }) => {
    const [isDocsLoading, setIsDocsLoading] = useState(true);

    useEffect(() => {
      const timer = setTimeout(() => setIsDocsLoading(false), 1000);
      return () => clearTimeout(timer);
    }, []);

    const edocs = [
      {
        id: 1,
        doc: {
          name: "Employee Handbook (2026-2027)",
          link: "/api/docs/EMPLOYEE-HANDBOOK-(2026-2027).5d7509e3d5f23e5a57e6.pdf",
        },
        date: "2026-01-12",
      },
    ];

    const ITEMS_PER_PAGE = 10;
    const totalPages = Math.ceil(edocs.length / ITEMS_PER_PAGE);
    const [currentPage, setCurrentPage] = useState(1);

    const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
    const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;

    return (
      <>
        <Table striped responsive bordered className="text-center">
          <thead>
            <tr>
              {(isAllowedToUpdate || isAllowedToDelete) && <th></th>}
              <th>S No.</th>
              <th>Documnet</th>
              <th>Last updated</th>
              {(isAllowedToUpdate || isAllowedToDelete) && <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {edocs.length > 0 ? (
              edocs
                .slice(indexOfFirstItem, indexOfLastItem)
                .map((row, index) => (
                  <tr key={row.id}>
                    {(isAllowedToUpdate || isAllowedToDelete) && (
                      <td>
                        <Form.Check
                          type="checkbox"
                          name="row"
                          value={row.id}
                          checked={selectedRow?.id === row.id}
                          onChange={(e) => handleCheckboxChange(e, row)}
                        />
                      </td>
                    )}
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>
                      <a href={row.doc.link} target="_blank" rel="noopener noreferrer">
                        {row.doc.name}
                      </a>
                    </td>
                    <td>{formatDate(row.date, "dd-MM-yyyy")}</td>
                    {(isAllowedToUpdate || isAllowedToDelete) && (
                      <td>
                        {isAllowedToUpdate && (
                          <Button
                            size="sm"
                            variant="outline-primary"
                            className="me-2"
                            disabled={!selectedRow || selectedRow?.id !== row.id}
                            onClick={handleEdit}
                          >
                            <i className="bi bi-pencil-square"></i>
                          </Button>
                        )}
                        {isAllowedToDelete && (
                          <Button
                            size="sm"
                            variant="outline-danger"
                            disabled={!selectedRow || selectedRow?.id !== row.id}
                            onClick={deleteHolidayManage}
                          >
                            <i className="bi bi-trash3"></i>
                          </Button>
                        )}
                      </td>
                    )}
                  </tr>
                ))
            ) : (
              <tr className="bg-light border text-center">
                <td colSpan={6} className="text-muted">
                  {isDocsLoading ? "Loading Data..." : "No Data Found"}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <div className="d-flex justify-content-end">
          <HRPagination
            totalPages={totalPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      </>
    );
  }
);

export default HolidayViewManagement;
